import { useTranslation } from '@thoughtspot/i18n';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { checklistDataTestId } from '../trial-info.util';
import styles from './checklist-button.module.scss';

interface ChecklistButtonProps {
    onOpenChecklistButtonClick: () => void;
    checklistButtonRef: React.RefObject<HTMLButtonElement>;
}

export const ChecklistButton: React.FC<ChecklistButtonProps> = ({
    onOpenChecklistButtonClick,
    checklistButtonRef,
}) => {
    const { t } = useTranslation();

    return (
        <div className={styles.buttonWrapper}>
            <button
                type="button"
                className={styles.button}
                onClick={onOpenChecklistButtonClick}
                ref={checklistButtonRef}
                data-tour-id="tour_checklist-explore-features-btn"
                data-testid={checklistDataTestId.CHECKLIST_BANNER_BUTTON}
            >
                <Typography variant="footnote" className={styles.buttonText}>
                    {t('freetrial.banner.checklist.exploreitems')}
                </Typography>
            </button>
        </div>
    );
};
